import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import ContactForm from '../components/ContactForm'

export default function KontaktPage() {
  return (
    <>
      <SEO
        title="Kontakt"
        description="Kontakt Havdrup Rengøring på tlf. 31 34 16 32 eller havdruprengoring@gmail.com for en uforpligtende snak og et godt tilbud på rengøring."
      />

      {/* Hero */}
      <section className="bg-gradient-to-b from-[#0d3836]/10 to-white py-12 sm:py-16 lg:py-20 border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <nav className="mb-6 flex items-center gap-2 text-xs text-slate-500" aria-label="Brødkrummer">
            <Link to="/" className="hover:text-slate-800 transition-colors">Forside</Link>
            <i className="fa-regular fa-chevron-right text-[10px]" aria-hidden="true" />
            <span className="font-semibold text-slate-900">Kontakt</span>
          </nav>

          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#0d3836]/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-[#0d3836]">
              <i className="fa-regular fa-phone text-[#0d3836]" aria-hidden="true" />
              Direkte dialog
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 font-display">
              Kontakt Havdrup Rengøring
            </h1>
            <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
              Vi tager gerne en uforpligtende snak om dine ønsker og giver et godt tilbud tilpasset din opgave. Udfyld formularen, eller ring direkte til os på hverdage.
            </p>
          </div>
        </div>
      </section>

      {/* Kontakt sektion med formular og info */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Kontakt informationer */}
            <div className="lg:col-span-5 space-y-6">
              <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-xs space-y-6">
                <div>
                  <h2 className="text-xl font-bold tracking-tight text-slate-900 font-display">
                    Virksomhedsoplysninger
                  </h2>
                  <p className="mt-1 text-xs text-slate-500">
                    Lokal rengøringsservice med base i Havdrup
                  </p>
                </div>

                <div className="space-y-5 text-sm text-slate-700">
                  {/* Adresse */}
                  <div className="flex items-start gap-3.5">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#0d3836]/10 text-[#0d3836]">
                      <i className="fa-regular fa-location-dot text-base" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-slate-500">
                        Adresse
                      </p>
                      <p className="text-base font-semibold text-slate-900 mt-0.5">
                        Havdrup Rengøring
                      </p>
                      <p className="text-slate-600">Sivvænget 6</p>
                      <p className="text-slate-600">4622 Havdrup</p>
                    </div>
                  </div>

                  {/* Telefon */}
                  <div className="flex items-start gap-3.5 pt-3 border-t border-slate-100">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#0d3836]/10 text-[#0d3836]">
                      <i className="fa-regular fa-phone text-base" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-slate-500">
                        Telefon
                      </p>
                      <a
                        href="tel:31341632"
                        className="text-base font-bold text-[#0d3836] hover:text-[#154e4a] transition-colors block mt-0.5"
                        aria-label="Ring på 31 34 16 32"
                      >
                        <span className="no-break">31 34 16 32</span>
                      </a>
                      <p className="text-xs text-slate-500 mt-0.5">
                        Ring gerne for en hurtig snak om din opgave
                      </p>
                    </div>
                  </div>

                  {/* E-mail */}
                  <div className="flex items-start gap-3.5 pt-3 border-t border-slate-100">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#0d3836]/10 text-[#0d3836]">
                      <i className="fa-regular fa-envelope text-base" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-slate-500">
                        E-mail
                      </p>
                      <a
                        href="mailto:havdruprengoring@gmail.com"
                        className="text-sm sm:text-base font-semibold text-[#0d3836] hover:text-[#154e4a] transition-colors block mt-0.5"
                        aria-label="Send e-mail til havdruprengoring@gmail.com"
                      >
                        <span className="no-break">havdruprengoring@gmail.com</span>
                      </a>
                      <p className="text-xs text-slate-500 mt-0.5">
                        Vi svarer hurtigst muligt på skriftlige henvendelser
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tryghedsboks */}
              <div className="rounded-2xl border border-[#0d3836]/15 bg-[#0d3836]/5 p-6 space-y-3">
                <h3 className="text-sm font-bold text-slate-900 font-display flex items-center gap-2">
                  <i className="fa-regular fa-shield-check text-[#0d3836]" aria-hidden="true" />
                  Hvorfor kontakte os?
                </h3>
                <ul className="space-y-2 text-xs sm:text-sm text-slate-700">
                  <li className="flex items-start gap-2">
                    <i className="fa-regular fa-check text-[#0d3836] mt-1 shrink-0" aria-hidden="true" />
                    <span>Helt uforpligtende samtale og tilbud på din opgave</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-regular fa-check text-[#0d3836] mt-1 shrink-0" aria-hidden="true" />
                    <span>Fleksibilitet omkring opstart og faste ugedage</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fa-regular fa-check text-[#0d3836] mt-1 shrink-0" aria-hidden="true" />
                    <span>Særlig erfaring med klinikker og behandlingsmiljøer</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Kontaktformular */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
